import { ValidationResult, Validator } from './interfaces';

const re = /^(?:\d{3}[ -]?){3}\d{2}$/;

export const SnilsValidator: Validator = class {
    /**
     * Проверка контрольной суммы
     */
    private static checkSum(value: string, checkSum: number) {
        const checkedValue = value.split('');

        const sum = checkedValue.reduce((acc, cv, idx) => acc + Number(cv) * (9 - idx), 0);

        if (sum < 100 && sum === checkSum) {
            return true;
        }
        if ((sum === 100 || sum === 101) && checkSum === 0) {
            return true;
        }
        if (sum > 101 && (sum % 101 === checkSum || (sum % 101 === 100 && checkSum === 0))) {
            return true;
        }
        return false;
    }

    static validate(snils: string): ValidationResult {
        const formatValid = re.test(snils);
        if (!formatValid)
            return { valid: false };
        const refinedValue = snils.replace(/\D+/g, '');
        const valid = this.checkSum(
            refinedValue.slice(0, 9),
            Number(refinedValue.slice(9))
        );
        return {
            valid,
            refinedValue
        };
    }
}